const ChooseProducts = ({ images, onDrawingClick, activeDrawing, descriptions, language }) => {

  const currentTags = descriptions[language]?.extraTags || [[], [], []];

  return (
    <div className="grid grid-cols-3 gap-4 mt-5 sm:mt-7 lg:mt-10">

      {images.map((imageObj, index) => (
        <div
          key={index}
          className="flex flex-col items-center"
        >

          {/* IMAGEN */}
          <img
            src={activeDrawing === index + 1 ? imageObj.animated : imageObj.static}
            alt={`Imagen ${index + 1}`}
            className={`w-full max-w-[200px] sm:max-w-[220px] md:max-w-[260px] lg:max-w-[320px] xl:max-w-[400px] h-auto cursor-pointer transition-all duration-500 ${
              activeDrawing === index + 1
                ? "image-active scale-105"
                : "opacity-90 hover:opacity-100"
            }`}
            onClick={() => onDrawingClick(index + 1)}
          />

          {/* BOTÓN */}
          <button
            style={{
              fontSize: "13px",
              transform: "translateY(-2px)"
            }}
            className={`mt-4 px-8 py-4 font-bold rounded-xl shadow-lg transition-all duration-300 whitespace-nowrap ${
              activeDrawing === index + 1
                ? "btn-active"
                : "btn-inactive"
            }`}
            onClick={() => onDrawingClick(index + 1)}
          >
            {descriptions[language].buttonText[index]}
          </button>

          {/* TEXTOS DESCRIPTIVOS */}
          <div
            className={`mt-3 text-center text-xl sm:text-sm leading-tight transition-colors duration-300 max-w-[90%] ${
              activeDrawing === index + 1
                ? "text-white"
                : "text-[#5dc7ff]"
            }`}
          >
            {currentTags[index].map((tag, i) => (
              <div key={i}>{tag}</div>
            ))}
          </div>

        </div>
      ))}

    </div>
  );
};

export default ChooseProducts;